// Generated file - do not change manually!

/**
 * Defines input types
 */
export enum InputType {
  /**
   * Used for input fields that must contain an e-mail address.
   */
  Email = 'Email',

  /**
   * Defines a numeric input field.
   */
  Number = 'Number',

  /**
   * Defines a password field.
   */
  Password = 'Password',

  /**
   * Used for input fields that should contain a telephone number.
   */
  Tel = 'Tel',

  /**
   * Defines a one-line text input field:
   */
  Text = 'Text',

  /**
   * Used for input fields that should contain a URL address.
   */
  URL = 'URL'
}
